import { Field, Switch } from "@chakra-ui/react";
import { Control, FieldValues, useController } from "react-hook-form";

interface Props {
  control: Control<FieldValues>;
  name: string;
  label?: string;
}

export const SwitchInput = ({ control, name, label }: Props) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <Field.Root invalid={!!error}>
      <Switch.Root
        name={field.name}
        checked={field.value}
        onCheckedChange={({ checked }) => field.onChange(checked)}
      >
        <Switch.HiddenInput onBlur={field.onBlur} />
        <Switch.Control />
        <Switch.Label>{label}</Switch.Label>
      </Switch.Root>
      <Field.ErrorText>{error?.message}</Field.ErrorText>
    </Field.Root>
  );
};
